import userlandingRoutes from "./Userlanding";

const userlandingRoutesMap = {
  ...userlandingRoutes,
};

export default userlandingRoutesMap;
